import { render, staticRenderFns } from "./WorkflowFormBuilderFieldMetaLabelAutoPicker.vue?vue&type=template&id=5f5b7246&"
import script from "./WorkflowFormBuilderFieldMetaLabelAutoPicker.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderFieldMetaLabelAutoPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports